import React, {Component} from 'react';
import {connect} from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from 'moment';

import { Grid, TextField, InputAdornment } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import { faSort, faSortAlphaDown, faSortAlphaUpAlt, faSortNumericDown, faSortNumericUpAlt, faTimesCircle, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

//Actions
import {getAllRepairs, getOpenRepairs,GetRepairsFilters} from '../../actions/repairAction';
import { getAllCommunities } from '../../actions/communityActions'
import RepairsFilters from './RepairsFilters';


const initFilters={
    statusSelected:[],
    dateChanged:false,
    dateOptionSelected: null,
    startDate: new Date(),
    endDate: new Date(),
    itemsSelected: [],
    issuesSelected: [],
    responseTime: false,
    responseOption: 'Greater than',
    lowerLimit: 1,
    upperLimit: 10,
    responseUnit:'hours'
}

class RepairsOpen  extends Component{
    constructor(props){
        super(props);

        this.state = {
            repairsSelected: [],
            stillOpen: true,

            filtersOpenedObj: { ...initFilters, statusSelected:[],itemsSelected: [], issuesSelected: [] },
            filtersOpenedAnchorEl: null,
            filtersOpenedApply:false,
            openSearchOpened: false,
            searchOpenedValue: '',
            sortOpenedColumn: 'createdDate',
            sortOpenedDesc: false,
        }

        this.observer = React.createRef();
        this.lastOpenRef = node => {
            /* FUNCTION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver( async(entries) => {
                let openNodes = document.querySelectorAll('[id^="Repairs_row_"]')
                let openNodeLastVisibleId = `Repairs_row_${openNodes.length-2}`
                // let nextToEndNode = document.querySelectorAll(`[id^=${openNodeLastVisibleId}]`)
                // nextToEndNode = (nextToEndNode && nextToEndNode.length > 0)? nextToEndNode[0] : undefined;
                //let nextToEndNode = (openNodes && openNodes.length > 0)?openNodes[openNodes.length-1]: undefined
                const nodeList = document.querySelectorAll('[data-lastelementopen $="Last_Element_Open"]');
                let node = (nodeList && nodeList.length> 0)? nodeList[0]: undefined;

                if (entries[0].isIntersecting) {
                    if(openNodeLastVisibleId){
                        setTimeout(() => {
                            let nextToEndNode = document.querySelectorAll(`[id^=${openNodeLastVisibleId}]`)
                            nextToEndNode = (nextToEndNode && nextToEndNode.length > 0)? nextToEndNode[0] : undefined;

                            if(nextToEndNode)
                                nextToEndNode.scrollIntoView(false);
                        }, 1100);
                    }

                    if(node){
                        node= undefined;
                    }
                    const newCurrentPage = this.state.currentPageOpended? this.state.currentPageOpended +1: 1;
                    const res = await this.getOpenScrollingRepair(newCurrentPage)

                    this.setState((prevState) => ({ currentPageOpended: newCurrentPage , stillOpen: res}));
                    
                    setTimeout(() => this.forceUpdate(), 1000);
                }
            });
            if (node) this.observer.current.observe(node)
        };

    }
    componentDidMount = () =>{

        const communityId = localStorage.getItem('communityId');
        
        if(communityId && this.state.community){
            this.setState({communityId: communityId})
        }
        
        if (!this.props.communityData || (this.props.communityData && this.props.communityData.length === 0)) {
            this.props.getAllCommunities();
        }
        
        if (localStorage.getItem('superAdmin') === "false" || (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0)){
            if(this.props.updState){
                this.setState(this.props.updState, () => this.getRepairs())
            }else{
                this.getRepairs();
            }
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.communityId!==this.props.communityId){
            this.setState({
                currentPageOpended:0,
                filtersOpenedObj: { ...initFilters, statusSelected:[],itemsSelected: [], issuesSelected: [] },
                filtersOpenedAnchorEl: null,
                filtersOpenedApply:false,
                openSearchOpened: false,
                searchOpenedValue: '',
                sortOpenedColumn: 'createdDate',
                sortOpenedDesc: false,
            })
        }
    }

    //#region Methods
    getRepairs = async () => {
        this.props.getAllRepairs(localStorage.getItem('communityId'));
        await this.getOpenScrollingRepair();
    };

    getOpenScrollingRepair = async(page) => {
        let resOpenRequest = undefined;
        if(this.state.filtersOpenedApply){
            resOpenRequest = await this.GetRepairsWithFilters();
        }else{
            resOpenRequest= await this.props.getOpenRepairs(localStorage.getItem('communityId'), page? page: 0);
        }

        return (resOpenRequest && resOpenRequest.ok)? true: false
    };

    handleSort = (column) => {

        const currentColumn = this.state.sortOpenedColumn;

        const updState = {
            sortOpenedColumn: currentColumn,
            sortOpenedDesc: this.state.sortOpenedDesc,
            currentPageOpended: 0,
            filtersOpenedApply: true,
            stillClose: true,
            stillOpen: true
        }

        if(currentColumn!==column){
            updState.sortOpenedColumn = column
            updState.sortOpenedDesc = true;
        }else{
            updState.sortOpenedDesc = !this.state.sortOpenedDesc
        }

        if(this.props.onUpdateFilters){
            this.props.onUpdateFilters(updState)
        }
        this.setState(updState,()=>this.GetRepairsWithFilters());
    }

    async GetRepairsWithFilters(){

        const id = localStorage.getItem('communityId');
        const page =  this.state.currentPageOpended 
        const objFilters = this.state.filtersOpenedObj
        const searchValue = this.state.searchOpenedValue
        const sort = this.state.sortOpenedColumn? this.state.sortOpenedColumn :  'createdDate'
        const sortDirection = this.state.sortOpenedDesc;

        const res = await this.props.GetRepairsFilters(id, 1, objFilters, page, searchValue, sort, sortDirection );
        return res
    };

    handleSearch = () => {
        this.setState({ filtersOpenedApply: true, currentPageOpended: 0 }, () => this.GetRepairsWithFilters());

    }

    handleResetSearch = () => {
        this.setState({ searchOpenedValue:'', openSearchOpened: false, currentPageOpended: 0 }, () => this.GetRepairsWithFilters());


    }

    handleSort = (column) => {

        const currentColumn = this.state.sortOpenedColumn;

        const updState = {
            sortOpenedColumn: currentColumn,
            sortOpenedDesc: this.state.sortOpenedDesc,
            currentPageOpended: 0,
            filtersOpenedApply: true,
            stillClose: true,
            stillOpen: true
        }
    
        if(currentColumn!==column){
            updState.sortOpenedColumn = column
            updState.sortOpenedDesc = true;
        }else{
            updState.sortOpenedDesc = !this.state.sortOpenedDesc
        }

        this.setState(updState, ()=>this.GetRepairsWithFilters())
       


    }

    applyFilters = (filters) => {

        this.setState({ filtersOpenedObj: filters, currentPageOpended: 0, filtersOpenedApply: true, selectAllButton:false, repairsSelected:[] }, ()=>this.GetRepairsWithFilters());

    }

    resetFilters = () => {

        if(this.state.sortOpenedColumn==='createdDate' && this.state.sortOpenedDesc===false){ //No sort applied
            this.setState({ 
                filtersOpenedObj: {...initFilters, itemsSelected:[], statusSelected:[], issuesSelected:[]}, 
                currentPageOpended: 0, 
                filtersOpenedApply: false, 
                openSearchOpened:false, 
                searchOpenedValue:'' 
            }, ()=>this.getOpenScrollingRepair());
        }else{
            this.setState({ 
                filtersOpenedObj: {...initFilters, itemsSelected:[], statusSelected:[], issuesSelected:[]}, 
                currentPageOpended: 0, 
                filtersOpenedApply: true, 
                openSearchOpened:false, 
                searchOpenedValue:'' 
            },()=>this.GetRepairsWithFilters());
        }
    
    }


    ToggleCheckBoxHandler = (repair) => {
        try{
            if (this.props.repairsSelected) {
                const arrayRepairsSelected = this.props.repairsSelected;
    
                const item = arrayRepairsSelected.find(item => item._id === repair._id);
    
                if (!item) {
                    arrayRepairsSelected.push(repair);
                }
                else {
                    const indexToDelete = arrayRepairsSelected.map(item => item._id).indexOf(repair._id);
    
                    arrayRepairsSelected.splice(indexToDelete, 1);
                }
    
                if(this.props.onRepairsSelected){
                    this.props.onRepairsSelected(arrayRepairsSelected)

                }
            }
        }catch(err){
        }
    };

   
    SelectAllRepairsHandler = () => {
        
        //const selectAllButton = !this.state.selectAllButton;
        let arrayRepairsSelected = this.props.repairsSelected ? this.props.repairsSelected : [];

        let repairsPending = this.props.currentDataOpen.length > 0 ? this.props.currentDataOpen : 0;

        if (repairsPending.length > arrayRepairsSelected.length) {
            if (this.props.currentDataOpen.length > 0) {
                repairsPending.forEach(item => {
                    const indexOfItemAllReadySelected = (this.props.repairsSelected) ? this.props.repairsSelected.map(item => item._id).indexOf(item._id) : -1;

                    if (indexOfItemAllReadySelected === -1) {
                        arrayRepairsSelected.push(item);
                    }
                });
            }
        }else {
            if (this.props.currentDataOpen.length > 0) {
                repairsPending.forEach(item => {
                    if (this.props.repairsSelected) {
                        const indexToDelete = this.props.repairsSelected.map(item => item._id).indexOf(item._id);

                        if (indexToDelete !== -1) {
                            arrayRepairsSelected.splice(indexToDelete, 1);
                        }
                    }
                });
            }
        }

        //, selectAllButton: selectAllButton
        if(this.props.onRepairsSelected){
            this.props.onRepairsSelected(arrayRepairsSelected)
        }

    };

    CancelRepair = (e, item ) =>{
        try{
            e.stopPropagation();
            if(this.props.onRepairSelectedForCancel){
                this.props.onRepairSelectedForCancel(Array.of(item))
            }
    
        }catch(err){
            return undefined
        }
    }
    //#endregion

    //#region Components Listing
    OpenRepairsHeaders = () =>{
        
        return(
            <Grid item container className='LRepairsOpenedHeaders'>
                <Grid item xs={1}>             
                </Grid>
                <Grid item xs={2}>
                    Resident
                    <IconButton onClick={()=>this.handleSort('resident.lastName')}>
                        <FontAwesomeIcon icon={
                            (this.state.sortOpenedColumn==='resident.lastName' && this.state.sortOpenedDesc)? 
                            faSortAlphaDown 
                            : 
                            (this.state.sortOpenedColumn==='resident.lastName' && !this.state.sortOpenedDesc)? 
                            faSortAlphaUpAlt 
                            : 
                            (this.state.sortOpenedColumn!=='resident.lastName')? 
                            faSort 
                            :
                            null
                            } 
                            color='#a2a1a2' 
                        />
                    </IconButton>
                </Grid>
                <Grid item xs={1} >
                    Location
                    <IconButton onClick={()=>this.handleSort('resident.zoneName')}>
                        <FontAwesomeIcon icon={
                            (this.state.sortOpenedColumn==='resident.zoneName' && this.state.sortOpenedDesc)? 
                            faSortAlphaDown 
                            : 
                            (this.state.sortOpenedColumn==='resident.zoneName' && !this.state.sortOpenedDesc)? 
                            faSortAlphaUpAlt 
                            : 
                            (this.state.sortOpenedColumn!=='resident.zoneName')? 
                            faSort 
                            :
                            null
                            } 
                            color='#a2a1a2' 
                        />
                    </IconButton>
                </Grid>
                <Grid item xs={1} >
                    Room
                    <IconButton onClick={()=>this.handleSort('room.name')}>
                        <FontAwesomeIcon icon={
                            (this.state.sortOpenedColumn==='room.name' && this.state.sortOpenedDesc)? 
                            faSortAlphaDown 
                            : 
                            (this.state.sortOpenedColumn==='room.name' && !this.state.sortOpenedDesc)? 
                            faSortAlphaUpAlt 
                            : 
                            (this.state.sortOpenedColumn!=='room.name')? 
                            faSort 
                            :
                            null
                            } 
                            color='#a2a1a2' 
                        />
                    </IconButton>
                </Grid>
                <Grid item xs={2}>
                    Item
                    <IconButton onClick={()=>this.handleSort('item.name')}>
                        <FontAwesomeIcon icon={
                            (this.state.sortOpenedColumn==='item.name' && this.state.sortOpenedDesc)? 
                            faSortAlphaDown 
                            : 
                            (this.state.sortOpenedColumn==='item.name' && !this.state.sortOpenedDesc)? 
                            faSortAlphaUpAlt 
                            : 
                            (this.state.sortOpenedColumn!=='item.name')? 
                            faSort 
                            :
                            null
                            } 
                            color='#a2a1a2' 
                        />
                    </IconButton>

                </Grid>
                <Grid item xs={1}>
                    Issue
                    <IconButton onClick={()=>this.handleSort('issue.name')}>

                        <FontAwesomeIcon icon={
                            (this.state.sortOpenedColumn==='issue.name' && this.state.sortOpenedDesc)? 
                            faSortAlphaDown 
                            : 
                            (this.state.sortOpenedColumn==='issue.name' && !this.state.sortOpenedDesc)? 
                            faSortAlphaUpAlt 
                            : 
                            (this.state.sortOpenedColumn!=='issue.name')? 
                            faSort 
                            :
                            null
                            } 
                            color='#a2a1a2' 
                        />
                    </IconButton>

                </Grid>
                <Grid item xs={1}>
                    Status
                    <IconButton onClick={()=>this.handleSort('orderStatus')}>
                        <FontAwesomeIcon icon={
                            (this.state.sortOpenedColumn==='orderStatus' && this.state.sortOpenedDesc)? 
                            faSortAlphaDown 
                            : 
                            (this.state.sortOpenedColumn==='orderStatus' && !this.state.sortOpenedDesc)? 
                            faSortAlphaUpAlt 
                            : 
                            (this.state.sortOpenedColumn!=='orderStatus')? 
                            faSort 
                            :
                            null
                            } 
                            color='#a2a1a2' 
                        />
                    </IconButton>

                </Grid>
                <Grid item xs={2}>
                    Date Submitted
                    <IconButton onClick={()=>this.handleSort('createdDate')}>
                        <FontAwesomeIcon icon={
                            (this.state.sortOpenedColumn==='createdDate' && this.state.sortOpenedDesc)? 
                            faSortNumericDown 
                            : 
                            (this.state.sortOpenedColumn==='createdDate' && !this.state.sortOpenedDesc)? 
                            faSortNumericUpAlt 
                            : 
                            (this.state.sortOpenedColumn!=='createdDate')? 
                            faSort 
                            :
                            null
                            } 
                            color='#a2a1a2' 
                        />
                    </IconButton>

                </Grid>
                <Grid item xs={1}></Grid>
            </Grid>
        )
    }

    OpenRepairsOpenList = () =>{
        const currentDataOpen = this.props.currentDataOpen ? this.props.currentDataOpen  : [];
        if(!currentDataOpen || currentDataOpen.length ===0)
            return <Grid item container></Grid>

        return (
            <Grid item container xs={12}>
                {
                    currentDataOpen.map((item, index) => 
                        {
                            return(
                                <Grid item container  xs={12}
                                    key={'repair_open' + item._id} 
                                    id={`Repairs_row_${index}_${item._id}`} 
                                    onClick={() => {
                                        this.setState({ openRepairDetails: true, repairSelectedForDetails: item, repairSelectedForDetailsStatus: item.status, repairsSelected: [item] }) 
                                        if(this.props.onRepairSelectedForDetails){
                                            this.props.onRepairSelectedForDetails(true, item, item.status)
                                        }
                                    }
                                }
                                
                                >
                                    {
                                        (currentDataOpen && currentDataOpen.length === index+1) && this.state.stillOpen?
                                            <Grid item container xs={12}
                                                data-lastelementopen={(currentDataOpen && currentDataOpen.length === index +1)? 'Last_Element_Open':undefined} 
                                                ref={currentDataOpen.length === index + 1?this.lastOpenRef:undefined} 
                                            />
                                        :
                                            undefined
                                    }
                                    <this.SingleOpenRepairRow item={item} index={index}/>
                                </Grid>
                            )
                    }
                        )
                }
            </Grid>
        )
    }

    SingleOpenRepairRow = ({item, index}) =>{
        
        if(!item)
            return <Grid item container></Grid>;

        const residentName = (item.resident && item.resident.name) ? item.resident.name : 'N/A';
        const residentLastName = (item.resident && item.resident.lastName) ? item.resident.lastName : '';
        const residentZoneName = (item.resident && item.resident.zoneName) ? item.resident.zoneName : '';
        const roomName = (item.room && item.room.name)? item.room.name: '';

        const finalZoneName = (item && item.isCommonArea)?  roomName: residentZoneName;
        const finalRoomName = (item && item.isCommonArea)? '-': roomName
        
        const classesRow = (index%2 ===0)?'LRow LEvenRow ': 'LRow';

        return (
            <Grid item container xs={12} className={classesRow} style={{borderRadius:'10px', cursor:'pointer'}}>
                <Grid item container className=" CheckboxBlue" xs={1} md={1} justify='center' alignContent="center" >
                    <Grid item>
                        <Checkbox
                            className='CheckboxBlue'
                            checked={this.props.repairsSelected && this.props.repairsSelected.length > 0 ? this.props.repairsSelected.find(repair => repair._id === item._id) !== undefined ? true : false : false}
                            onChange={(e) => { this.ToggleCheckBoxHandler(item) }}
                            onClick={(e) => e.stopPropagation()}
                            icon={<CheckBoxOutlineBlankIcon  fontSize="large" />}
                            checkedIcon={<CheckBoxIcon style={{color: '#009edd' }} fontSize="large" />}
                            id={`Repair_checkbox_${item._id}`}
                        />
                    </Grid>
                </Grid>
                <Grid item container xs={12} md={2} style={{color:'#000000', fontFamily:'Gotham-Bold'}}>
                    <this.ResidentInfoComponent residentPictureUrl ={item.resident.residentPictureUrl} residentName={residentName} lastName={residentLastName}/>
                </Grid>
                <Grid item container xs={12} md={1}>
                    <this.ResidentLocationComponent location ={finalZoneName}/>
                </Grid>
                <Grid item container className=" medium-size-1 txt_black" xs={1} justifyContent='flex-start' alignContent='center'>
                    {finalRoomName}
                </Grid>
                <Grid item container xs={2}>
                    <this.RenderItemComponent item={item} />
                </Grid>
                <Grid item container className="txt_black medium-size" xs={1} id='repairsPage_Item_Issue' style={{fontSize:'16px'}} justifyContent='center' alignContent='center'>
                    <Grid item container>
                        {item.issue ? item.issue.name : ' '}
                    </Grid>
                </Grid>
                <Grid item container xs={1}>
                    <this.RenderStatusResponseComponent item={item} status={item.status} index={index}/>
                </Grid>
                <Grid item container xs={2} >
                    <this.ResidentSubmittedDateComponent DateSubmitted={(item && item.createdDate)? item.createdDate: undefined} />
                </Grid>
                <Grid item container xs={1}  alignContent='center' justifyContent='center'>
                    <Grid item>
                        <IconButton 
                            style={{cursor:'pointer'}}
                            onClick={(e)=> this.CancelRepair(e, item) }
                            classes={{
                                root:'BtnDisabledRipple'
                            }}
                        >
                            <FontAwesomeIcon icon={faTrashAlt } 
                                color='#c43740'
                                size='1x'
                            />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    ResidentInfoComponent = ({residentPictureUrl, residentName, lastName}) =>{
        try{

            return(
                <Grid item container id='repairsPage_ResidentImage' alignContent="center" justifyContent="center" >
                    <Grid item container xs={12} justifyContent='flex-start' alignContent='center'>
                        <Grid item className="txt_black large">
                            {
                                lastName?
                                `${lastName}, ${residentName}`
                                :
                                residentName
                            }
                        </Grid>
                    </Grid>
                </Grid>
            );
        }catch(err){
            return(
                <Grid item container>
                </Grid>
            )
        }
    }

    ResidentLocationComponent = ({location}) =>{
        try{
            return(
                <Grid item container alignContent="center" justifyContent="flex-start">
                    <Grid item  className="txt_black large" id='repairsPage_Location' style={{fontSize:'16px'}}>
                        {location ? location : ''}
                    </Grid>
                </Grid>
            );
        }catch(err){
            return(
                <Grid item container></Grid>
            );
        }
    }

    RenderItemComponent = ({ item }) => {
        let itemName = (item && item.item && item.item.name) ? item.item.name : '';
        const itemIconUrl = (item && item.item && item.item.iconUrl)? item.item.iconUrl : ''

        if (itemName) {
            itemName = itemName.charAt(0).toUpperCase() + itemName.slice(1);
        }

        return (
            <Grid item container xs={12} alignItems='center' id='repairsPage_Item'>
                <Grid item className="center" id='repairsPage_Item_Image'>
                    <img alt={'icon Item ' + itemName} src={itemIconUrl} className="LitemIcon logo-black"/>
                </Grid>
                <Grid item className="center medium-size-1 txt_black" style={{paddingLeft:'5px'}} id='repairsPage_Item_Name'>
                    {itemName}
                </Grid>
            </Grid>
        )
    };

    RenderStatusResponseComponent = ({ item, status }) => {
        const createdDate = item.createdDate ? item.createdDate : undefined;
        const scheduleDate = item.timeLine ? item.timeLine.find(item => item.title === 'Scheduled Date') : undefined;
        const today = new Date();
        const responseTime = (item.orderStatus === 'completed' && item.createdDate && item.repairDate) ? this.GetResponseTime(item.createdDate, item.repairDate) : 'N/A';

        let beforeYesterday = true;

        if (today && createdDate) {
            beforeYesterday = moment(today).subtract(1, 'day') >= moment(createdDate);
        }


        return (
            <Grid item container xs={12} id='repairsPage_Status'>
                {
                    item.orderStatus === 'pending' || item.orderStatus==='scheduled' ?
                        <Grid item container direction='column' justifyContent='center' alignContent='flex-start' >
                            <Grid item style={scheduleDate ? { color: '#105a88' } : beforeYesterday ? { color: '#c43740' } : { color: 'black' }} className="large-1">
                                {!scheduleDate ? 'Opened' : 'Scheduled for'}
                            </Grid>
                            <Grid item className="medium-size-1">
                                {
                                    scheduleDate ?
                                        moment(scheduleDate.timeLineDate).format('M/D hh:mm A')
                                        :
                                        ' '
                                }
                                { }
                            </Grid>
                        </Grid>
                        :
                        item.orderStatus === 'canceled' ?
                            <Grid item container justifyContent='flex-start' alignContent='center' direction='column'>
                                <Grid item className="large-1 center">{'N/A'}</Grid>
                                <Grid item className="large-1 center">{'Repair Canceled'}</Grid>
                            </Grid>
                            :
                            responseTime ?
                                <Grid item container justifyContent='center' alignItems='center'>
                                    <Grid item className="large-1 center">{responseTime}</Grid>
                                </Grid>
                                :
                                <Grid className="large-1 center">{'N/A'}</Grid>
                }
            </Grid>
        )
    };

    ResidentSubmittedDateComponent = ({DateSubmitted}) =>{
        try{
            const date = new moment(DateSubmitted);
            let dateFormatted = undefined;

            if(date && date._isValid){
                dateFormatted= date.format('MM/DD/yyyy');
            }

            return(
                <Grid item container justifyContent="flex-start" alignContent="center" style={{fontSize:'16px'}} className='txt_black'>
                    <Grid item>
                        {dateFormatted}
                    </Grid>
                </Grid>
            );
        }catch(err){
            return(
                <Grid item container></Grid>
            );
        }
    }
    //#endregion
    
    //#region Components Filtering
    FilterRow = () =>{
        return(
        <Grid item container>
            <Grid item container xs={12} md={12} justifyContent='flex-start' alignContent='center'>
                <this.SelectAllComponent/>
            </Grid>
        </Grid>
        )
    }

    SelectAllComponent = () =>{
        return (
        <Grid item container xs={12} alignItems='center' style={{padding:'5px 10px'}}>
            <Grid item container xs={4}>
                <Grid item style={{color:'#797979', fontSize:'20px', cursor:'pointer', fontFamily:'Gotham-Book'}} onClick={() => this.SelectAllRepairsHandler()}>
                    Select All
                </Grid>
                &nbsp;
                <Grid item style={{color:'#adadad', fontSize:'16px', paddingLeft:'10px'}}>
                    {` ${(this.props.repairsSelected && this.props.repairsSelected.length > 0)? this.props.repairsSelected.length : 0 } selected`}
                </Grid>
            </Grid>          
            <Grid item container xs={8} justifyContent='flex-end' alignContent='center'>
                {
                    this.state.openSearchOpened ?
                        <Grid item container xs={10} sm={10} md={6} lg={4} >
                            <TextField
                                id='closed_repairs_search'
                                name='Search'
                                item
                                placeholder="Enter search term(s) and press Enter"
                                value={this.state.searchOpenedValue}
                                fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <svg fill='#105A88' width='32px' height='32px' viewBox="0 0 576 512">                                   
                                                <path xmlns="http://www.w3.org/2000/svg" d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"/>
                                            </svg>
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton id='repairs_closed_clear_btn' onClick={() => this.handleResetSearch()}>
                                                <FontAwesomeIcon icon={faTimesCircle} color='#105a88' size='sm' />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                                inputProps={{
                                    className:'txt_black'
                                }}
                                className="repairs_search animate__animated animate__slideInRight"
                                onChange={(e) => this.setState({ searchOpenedValue: e.target.value })}
                                onKeyDown={(e) => { if (e && e.keyCode === 13) this.handleSearch() }}
                            />

                        </Grid>
                        :
                        <IconButton  onClick={() => this.setState({ openSearchOpened: true })} id='search_Opened_btn'>
                            <svg fill='#105A88' width='35px' height='35px' viewBox="0 0 576 512">                                   
                                <path xmlns="http://www.w3.org/2000/svg" d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"/>
                            </svg>                                    
                        </IconButton>
                }
                <IconButton 
                    onClick={(e) => this.setState({ filtersOpenedAnchorEl: e.currentTarget })} 
                    id='filters_opened_btn' 
                >                            
                    <svg fill='#105A88' width='35px' height='35px' viewBox="0 0 576 512">                                   
                        <path xmlns="http://www.w3.org/2000/svg" d="M479.968 0H32.038C3.613 0-10.729 34.487 9.41 54.627L192 237.255V424a31.996 31.996 0 0 0 10.928 24.082l64 55.983c20.438 17.883 53.072 3.68 53.072-24.082V237.255L502.595 54.627C522.695 34.528 508.45 0 479.968 0zM288 224v256l-64-56V224L32 32h448L288 224z"/>
                    </svg>
                            
                </IconButton>
            </Grid>
        </Grid>
        )
    }
    //#endregion

    render(){
        return(
            <Grid item container style={{padding:'20px'}}>
                <Grid item container>
                    <this.FilterRow/>
                </Grid>
                <Grid item container >
                    <this.OpenRepairsHeaders/>
                </Grid>
                <Grid item container xs={12}>
                    <this.OpenRepairsOpenList  />
                </Grid>
                {                     
                    this.state.filtersOpenedAnchorEl &&
                    <RepairsFilters
                        anchorEl={this.state.filtersOpenedAnchorEl}
                        onClose={() => this.setState({ filtersOpenedAnchorEl: null })}
                        filters={this.state.filtersOpenedObj}
                        tab={1}
                        applyFilters={this.applyFilters}
                        resetFilters={this.resetFilters}
                    />                
                }
            </Grid>
        )
    }
}



function mapStateToProps(state,dispatch) {
    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData : [];
    let currentDataOpen = (state.repairReducer?.dashboardRepairData?.openS)?state.repairReducer?.dashboardRepairData?.openS : [];

    currentDataOpen = currentDataOpen.map((r) => {
        let newRepair= r

        if(newRepair && newRepair.resident && !newRepair.resident.name && !newRepair.resident.lastName){
            newRepair.resident.name = 'N/A'
        }
        
        return newRepair
    })

    
    return{
        currentDataOpen,
        communityData,
    }
};

export default connect(mapStateToProps,{GetRepairsFilters, getAllRepairs, getOpenRepairs, getAllCommunities})(RepairsOpen)